import React, { useMemo } from 'react'
import { Vendor } from '../../lib/types/Vendor'
import { getImageURL } from '../../lib/utils/getImageURL'
import { Button } from '@demandlocal/components'
import { VENDOR } from '../../lib/utils/vendors'
import ConnectCentroForm from '../../forms/LinkedAccounts/ConnectCentro'
import { useModal } from '../useModal'
import ConnectBrevoForm from '../../forms/LinkedAccounts/ConnectBrevo'
import { openSignInWindow } from '../../lib/utils/openSigninWindow'
import { useDealership } from '../../store/zustand/dealershipStore'

type Props = {
  vendor: Vendor
  disabled?: boolean
}

export default function NotConnectedVendorAccount({
  vendor,
  disabled,
}: Props): JSX.Element {
  const dealership = useDealership()
  const { handleModal } = useModal()
  const getLinkForButton = useMemo(() => {
    if (vendor.id === VENDOR.Centro) {
      return (e) => {
        e.preventDefault()
        handleModal(<ConnectCentroForm />)
      }
    } else if (vendor.id === VENDOR.Brevo) {
      return (e) => {
        e.preventDefault()
        handleModal(<ConnectBrevoForm />)
      }
    } else if (
      vendor.id === VENDOR.Google ||
      vendor.id === VENDOR.GoogleAnalytics ||
      vendor.id === VENDOR.Facebook ||
      vendor.id === VENDOR.HubSpot
    ) {
      return (e) => {
        e.preventDefault()
        openSignInWindow(
          `${import.meta.env.VITE_API_URL}${String(
            vendor.api_oauth_endpoint,
          )}?current_organization_id=${dealership?.organization_id}&scope=${
            vendor.required_scopes
          }&vendor_id=${vendor.id}`,
          `LinkOne ${vendor.name} Integration`,
        )
      }
    } else if (vendor.id === VENDOR.TradeDesk || vendor.id === VENDOR.AmazonCognition) {
      return (e) => {
        e.preventDefault()
        window.open('mailto:integrations@link1data.com', '_blank')
      }
    } else {
      return (e) => {
        e.preventDefault()
        openSignInWindow(
          `${import.meta.env.VITE_API_URL}${String(
            vendor.api_oauth_endpoint,
          )}?current_organization_id=${dealership?.organization_id}&vendor_id=${
            vendor.id
          }`,
          `LinkOne ${vendor.name} Integration`,
        )
      }
    }
  }, [
    dealership?.organization_id,
    handleModal,
    vendor.api_oauth_endpoint,
    vendor.id,
    vendor.name,
    vendor.required_scopes,
  ])

  return (
    <div className="flex justify-between items-center py-5">
      <div className="flex flex-col gap-2">
        <div className="flex flex-row gap-2 items-center justify-start">
          {vendor?.logo ? (
            <img
              src={getImageURL(`images/vendors/${vendor.logo}`)}
              className="h-10 w-10 object-contain"
            />
          ) : (
            <></>
          )}
          <span className="font-bold text-lg">{vendor.name}</span>
        </div>
        {vendor.id === VENDOR.GoogleAnalytics && (
          <div className="font-bold text-sm text-secondary-bittersweet-red">
            *Once connected, we will automatically fetch data for the last 30 days
          </div>
        )}
      </div>
      <Button variant="secondary" disabled={disabled} onClick={getLinkForButton}>
        Connect
      </Button>
    </div>
  )
}
